import { Component, HostListener, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { MenustateService } from '../../services/shared/menustate.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.css'
})
export class LayoutComponent implements OnInit {
  isSidebarCollapsed = false;
  isMobileView = false;
  loading$: Observable<boolean>;

  constructor(
    private menuStateService: MenustateService,
    private router: Router
  ){
    this.loading$ = this.menuStateService.loading$;
  }

  ngOnInit(): void {
    this.updateSidebarState();

    this.router.events.subscribe(event => {
      if(event instanceof NavigationStart) {
        this.menuStateService.show();
      }

      if(
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.menuStateService.hide();
      }
    })
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: UIEvent): void {
    this.updateSidebarState();
  }

  updateSidebarState() {
    if(window.innerWidth < 768) {
      this.isSidebarCollapsed = true;
      this.isMobileView = true;
    }
    else{
      this.isSidebarCollapsed = this.isSidebarCollapsed;
      this.isMobileView = false;
    }
  }

  updateCollapseValue(newVale: boolean) {
    this.isSidebarCollapsed = newVale;
  }
}
